export const constants = {
  // STS auth
  AUTH0_DOMAIN: process.env.REACT_APP_AUTH0_DOMAIN || "",
  AUTH0_CLIENT_ID: process.env.REACT_APP_AUTH0_CLIENT_ID || "",
  AUTH0_CONNECTION: process.env.REACT_APP_AUTH0_CONNECTION || "",
  AUTH0_CALLBACK_URL: process.env.REACT_APP_AUTH0_CALLBACK_URL || "",
  AUTH0_AUDIENCE: process.env.REACT_APP_AUDIENCE || "",

  // Role manager api
  ROLE_MANAGER_API_BASE_URL: process.env.REACT_APP_ROLE_MANAGER_API_BASE_URL,
};

export default constants;
